module.exports = __webpack_public_path__ + "../../../static/img/exr_03.f2333c01.png";